import { useEffect, useState } from 'react';

import { NextPage } from 'next';
import { NextRouter, useRouter } from 'next/router';

import ConsumptionPage from 'src/components/consumptionPage';
import Fallback from 'src/components/Fallback/Fallback';
import { getSeoData } from 'src/components/pageMeta/SEOMetaUtils';
import { ContentTypes } from 'src/components/thumbnail/types';
import { useAppStore } from 'src/hooks/useAppStore';
import { Fallback_Type_Constants } from 'src/utils/constants/FallbackTypeConstants';
import {
  ConsumptionPageUrls,
  CountryCode,
  DisplayLanguage
} from 'src/utils/constants/stringConstants';

const LatestEpisodeConsumptionPage: NextPage<any> = () => {
  const { usersPreferenceData, usersLocationData, appConfig } = useAppStore();

  const router = useRouter();
  const { locale, asPath, query }: NextRouter = router;
  const countryCode = usersLocationData?.country_code || CountryCode.IN;
  const contentId = query.showId as string;
  const [seoMetaAssets, setSeoMetaAssets] = useState({});

  const fetchSeoMetaAssets = async () => {
    const seoMetaAssetsData = await getSeoData(
      countryCode,
      usersPreferenceData?.display_language || DisplayLanguage.ENGLISH,
      router.asPath
    );
    if (seoMetaAssetsData) {
      setSeoMetaAssets(seoMetaAssetsData);
    }
  };

  useEffect(() => {
    fetchSeoMetaAssets();
  }, []);

  if (appConfig.isRequestedByBot) {
    return <Fallback type={Fallback_Type_Constants.NOT_AVAILABLE} />;
  }
  return (
    <ConsumptionPage
      pageDetails={{
        showId: contentId,
        locale: locale as string,
        contentType: asPath.includes(ConsumptionPageUrls.TVSHOWS_CONSUMPTION)
          ? ContentTypes.tvshows
          : ContentTypes.webSeries,
        isLatestRoute: true
      }}
      seoMetaAssets={seoMetaAssets}
    />
  );
};
export async function getServerSideProps() {
  return {
    props: {}
  };
}

export default LatestEpisodeConsumptionPage;
